module.exports = __webpack_public_path__ + "assets/overview-campaign.461cb962.svg";